import { useQuery } from './query'
import { useToolbar } from './toolbar'
import { useSort } from './sort'
import { useAiAssistant } from './ai-assistant'
import { useEdit } from './edit'
import { useRow } from './row'
import { useImportExport } from './import-export'
import { useCustom } from './custom'
import { useCheckbox } from './checkbox'
import { useNavigate } from './navigate'
import { useFooter } from './footer'
import { useColumnMenu } from './column-menu'
import { useContextMenu } from './row-context-menu'
import { attachGridColumnWidthMethods } from './column-width'
import type { DataGrid } from '../types'

export function attachGridMethods($grid: DataGrid) {
  useQuery($grid)
  useRow($grid)
  useToolbar($grid)
  useSort($grid)
  useAiAssistant($grid)
  useEdit($grid)
  useImportExport($grid)
  useCustom($grid)
  useCheckbox($grid)
  useNavigate($grid)
  useFooter($grid)
  useColumnMenu($grid)
  useContextMenu($grid)
  attachGridColumnWidthMethods($grid)
}
